import { useEffect, useState } from 'react';
import { CookieAcceptDialog, CookiePersonalizeDialog } from "@gisce/oficina-virtual-components";
import { Box } from "@mui/material";
import { useSettingsContext } from '../Settings/hooks/useSettingsContext';
import { useCookies } from "@/hooks/useCookies";
import { notifyConsentChanged, OPEN_LEGACY_COOKIE_SETTINGS_EVENT } from "@/services/consent";

const CookieDialog = () => {
  const {acceptConsentCookies, acceptPreferencesCookies, acceptStatisticCookies, acceptMarketingCookies, revokeConsentCookies, acceptAllCookies, acceptCookies, hasAcceptedCookies} = useCookies();

  const [showPreferences, setShowPreferences] = useState(false);
  const [showBanner, setShowBanner] = useState(!hasAcceptedCookies());
  const Settings = useSettingsContext();

  // Reopened from the cookie settings link so the user can change or withdraw their consent.
  useEffect(() => {
    const openSettings = () => {
      setShowPreferences(true);
      setShowBanner(true);
    };
    window.addEventListener(OPEN_LEGACY_COOKIE_SETTINGS_EVENT, openSettings);
    return () => window.removeEventListener(OPEN_LEGACY_COOKIE_SETTINGS_EVENT, openSettings);
  }, []);

  const acceptedCookiesMap = {
    consent: acceptConsentCookies,
    preferences: acceptPreferencesCookies,
    statistics: acceptStatisticCookies,
    marketing: acceptMarketingCookies,
  };

  const acceptCookiesDialog = (acceptedCookies) => {
    setShowBanner(false);
    setShowPreferences(false);
    if (acceptedCookies === "all") {
      acceptAllCookies();
    } else if (typeof acceptedCookies === "object") {
      for (const [key, value] of Object.entries(acceptedCookies)) {
        if(value) {
          acceptedCookiesMap[key]();
        } else if (key !== "consent") {
          revokeConsentCookies(key);
        }
      }
      acceptCookies();
    }
    notifyConsentChanged();
  };

  const personalizeCookies = () => {
    setShowPreferences(true);
  };

  return (
    <Box sx={{position: "fixed", bottom: 0, width: "100%", zIndex: 10 }}>
      {showBanner && !showPreferences && (
        <CookieAcceptDialog
          acceptCookies={acceptCookiesDialog}
          personalizeCookies={personalizeCookies}
          cookiePolicyHref={Settings?.links?.cookies}
        />
      )}
      {showBanner && showPreferences && (
        <CookiePersonalizeDialog
          acceptCookies={acceptCookiesDialog}
          cookiePolicyHref={Settings?.links?.cookies}
        />
      )}
    </Box>
  );
}

export default CookieDialog;
